export let fieldInputs = {
    coordinate: [],
    link: [{
        type: "text",
        label: 'editor.link',
        name: 'link',
        width: '100%',
        value: ''
    }],
    date: [
        // {
        //     type: "checkbox",
        //     label: "editor.binning",
        //     name: "binning",
        //     toggle: "binning",
        //     charts: []
        // },
        {
            type: 'select',
            label: '',
            class: 'binning',
            default: 'day',
            name: 'binning',
            width: '100%',
            options: [
                { name: 'date.year', value: 'year' },
                { name: 'date.month', value: 'month' },
                { name: 'date.week', value: 'week' },
                { name: 'date.day', value: 'day' },
                { name: 'date.hour', value: 'hour' },
                { name: 'date.minute', value: 'minute' },
                { name: 'date.second', value: 'second' },
            ],
        },
        {
            type: 'checkbox',
            label: 'editor.periodic',
            class: 'binning',
            width: '110px',
            name: 'periodic',
        },
        {
            type: 'select',
            label: '',
            class: 'sort',
            default: 'ascending',
            name: 'order',
            width: '100%',
            options: [
                { name: 'editor.ascending', value: 'ascending' },
                { name: 'editor.descending', value: 'descending' },
            ],
        },
    ],
    number: [
        {
            type: 'checkbox',
            label: 'editor.binning',
            name: 'binning',
            toggle: 'binning',
        },
        {
            type: 'number',
            label: 'editor.binSize',
            class: 'binning',
            default: '1',
            name: 'binningValue',
            width: '100%'
        },
        {
            type: 'select',
            label: '',
            class: 'sort',
            default: 'ascending',
            name: 'order',
            width: '100%',
            options: [
                { name: 'editor.ascending', value: 'ascending' },
                { name: 'editor.descending', value: 'descending' },
            ],

        }],
    string: [
        // {
        //     type: "checkbox",
        //     label: "editor.binning",
        //     name: "binning",
        //     toggle: "binning"
        // },
        {
            type: 'select',
            label: 'editor.sortBy',
            class: 'sort',
            default: 'category',
            name: 'sort',
            width: '120px',
            options: [
                { name: 'editor.categorys', value: 'category' },
                { name: 'editor.value', value: 'value' },
            ],
        },
        {
            type: 'select',
            label: 'editor.order',
            class: 'sort',
            default: 'ascending',
            name: 'order',
            width: '120px',
            options: [
                { name: 'editor.ascending', value: 'ascending' },
                { name: 'editor.descending', value: 'descending' },
            ],
        },
        {
            type: 'number',
            label: 'editor.limitResult',
            class: 'limit',
            name: 'limit',
            default: 100,
            width: '100%',
        },
    ],
    boolean: [],
    objectid: [
        {
            type: 'select',
            label: 'editor.sortBy',
            class: 'sort',
            default: 'category',
            name: 'sort',
            width: '120px',
            options: [
                { name: 'editor.categorys', value: 'category' },
                { name: 'editor.value', value: 'value' },
            ],
        },
        {
            type: 'select',
            label: 'editor.order',
            class: 'sort',
            default: 'ascending',
            name: 'order',
            width: '120px',
            options: [
                { name: 'editor.ascending', value: 'ascending' },
                { name: 'editor.descending', value: 'descending' },
            ],
        },
        {
            type: 'number',
            label: 'editor.limitResult',
            class: 'limit',
            name: 'limit',
            default: 100,
            width: '100%',
        },
    ],
};